export const regex = {
  numeric: /\D/g,
  zipCode: /(\d{5})(\d{3})(.?)/,
};
